import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {IntegrationModule} from "../entity/integration-module";
import {Observable} from "rxjs/Observable";

@Injectable()
export class IntegrationModuleService {

    constructor(private _http: Http) {
    }

    getAvailabilityForClientProfile(profileId: number): Observable<IntegrationModule[]> {
        return this._http
            .get(`/api/backoffice/customers/${profileId}/integration-modules`)
            .map(response => response.json());
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/integration-module.service.ts